import { Package, Edit2, Trash2, Eye } from 'lucide-react';

export const ProductsList = ({
                                 products,
                                 companies,
                                 onEdit,
                                 onDelete,
                                 onView,
                                 loading = false
                             }) => {
    const getCompanyName = (companyId) => {
        console.log('Looking for company with ID:', companyId);
        console.log('Available companies:', companies);

        // Try different ways to match the company
        const company = companies.find(c => {
            // Handle both string and number IDs
            return c.id === companyId ||
                c.id === Number(companyId) ||
                String(c.id) === String(companyId);
        });

        if (company) {
            console.log('Found company:', company);
            return company.name;
        } else {
            console.log('Company not found for ID:', companyId);
            return 'Unknown Company';
        }
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    };

    const getTypeColor = (type) => {
        const colors = {
            'INSURANCE': 'bg-blue-100 text-blue-800',
            'INVESTMENT': 'bg-green-100 text-green-800',
            'LOAN': 'bg-purple-100 text-purple-800',
            'SAVINGS': 'bg-yellow-100 text-yellow-800'
        };
        return colors[type] || 'bg-gray-100 text-gray-800';
    };

    // Debug: Log the first product to see its structure
    if (products.length > 0) {
        console.log('Sample product structure:', products[0]);
    }

    if (products.length === 0 && !loading) {
        return (
            <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
                <Package className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                <p className="text-gray-600 mb-4">No products found</p>
                <p className="text-sm text-gray-500">Try adjusting your filters or add a new product</p>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            <div className="overflow-x-auto">
                <table className="w-full">
                    <thead className="bg-gray-50 border-b border-gray-200">
                    <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Product
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Company
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Type
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Amount Range
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Status
                        </th>
                        <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Actions
                        </th>
                    </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                    {products.map((product) => (
                        <tr key={product.id} className="hover:bg-gray-50 transition">
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div>
                                    <p className="text-sm font-medium text-gray-900">{product.name}</p>
                                    <p className="text-sm text-gray-500">Code: {product.code}</p>
                                </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div>
                                    <p className="text-sm text-gray-900">
                                        {/* Try multiple ways to get company name */}
                                        {product.companyName ||
                                            product.company?.name ||
                                            getCompanyName(product.companyId)}
                                    </p>
                                    {/* Debug info - remove in production */}
                                    <p className="text-xs text-gray-400">
                                        ID: {product.companyId}
                                    </p>
                                </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                    <span className={`px-2 py-1 text-xs rounded-full ${getTypeColor(product.type)}`}>
                                        {product.type}
                                    </span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {formatCurrency(product.minAmount)} - {formatCurrency(product.maxAmount)}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                    <span className={`px-2 py-1 text-xs rounded-full ${
                                        product.active
                                            ? 'bg-green-100 text-green-800'
                                            : 'bg-gray-100 text-gray-800'
                                    }`}>
                                        {product.active ? 'Active' : 'Inactive'}
                                    </span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                <div className="flex items-center justify-center gap-2">
                                    <button
                                        onClick={() => onView(product)}
                                        className="text-gray-600 hover:text-blue-600 transition"
                                        title="View Details"
                                    >
                                        <Eye className="w-4 h-4" />
                                    </button>
                                    <button
                                        onClick={() => onEdit(product)}
                                        className="text-indigo-600 hover:text-indigo-900 transition"
                                        title="Edit Product"
                                    >
                                        <Edit2 className="w-4 h-4" />
                                    </button>
                                    <button
                                        onClick={() => onDelete(product)}
                                        className="text-red-600 hover:text-red-900 transition"
                                        title="Delete Product"
                                    >
                                        <Trash2 className="w-4 h-4" />
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ProductsList;
